import AuthService from '../../services/AuthService'
import * as type from '../actionType'
import { getToken, removeToken } from '../../utils/tokenStorage'

type AppDispatchType = any
const authService = new AuthService()
const windowObj: any = window

export const resetState = () => async (dispatch: AppDispatchType) => {
  const token = getToken()
  dispatch({
    type: type.LOGIN_PROCESS_STARTED,
    payload: {
      isLoggedIn: token ? true : false,
      token: token,
    },
  })
  return Promise.resolve(true) // Intentionally return true, false will be handled by wrapper
}

export const processAuthState =
  (code: string) => async (dispatch: AppDispatchType) => {
    try {
      dispatch({
        type: type.LOGIN_PROCESS_STARTED,
        isLoggedIn: false,
        token: null,
      })
      const response = await authService.getTokenFromOneAuth(code)
      dispatch({
        type: type.LOGIN_PROCESS_COMPLETED,
        payload: {
          token: response.data.access_token,
          isLoggedIn: true,
        },
      })
      return Promise.resolve(response.data.access_token)
    } catch (error: any) {
      console.log('error', error)
      dispatch({
        type: type.LOGIN_PROCESS_FAIL,
        payload: {
          token: null,
          isLoggedIn: false,
        },
      })
      return Promise.resolve(null)
    }
  }

export const logoutUser = () => async (dispatch: AppDispatchType) => {
  removeToken()
  localStorage.clear()
  dispatch({
    type: type.LOGIN_PROCESS_STARTED,
    isLoggedIn: false,
    token: null,
  })
  window.location.href =
    windowObj.REACT_APP_ONE_AUTH_DOMAIN +
    '/logout?redirect_uri=' +
    window.location.origin +
    windowObj.SUB_DOMAIN +
    '/'
}
